"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9149],{

/***/ 78150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D4": function() { return /* binding */ getLocationsAutocompleteSelfDatabase; },
/* harmony export */   "Fx": function() { return /* binding */ getSearchKeywords; },
/* harmony export */   "U_": function() { return /* binding */ getLocationDetails; },
/* harmony export */   "iN": function() { return /* binding */ getLocationsAutocomplete; },
/* harmony export */   "z1": function() { return /* binding */ getSearchAutocomplete; }
/* harmony export */ });
/* harmony import */ var _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5001);
/* harmony import */ var _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57947);
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66548);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var basePath = "https://www.doctify.com/webapi";
var internalApiUrl = "https://www.doctify.com";
var getLocationsAutocomplete = function() {
    var _ref = _asyncToGenerator(_builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var searchString, lang, language, lat, lon, query;
        return _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    searchString = param.searchString, lang = param.lang, language = param.language, lat = param.lat, lon = param.lon;
                    query = (0,_utils_query__WEBPACK_IMPORTED_MODULE_2__/* .transformToQuery */ .aR)({
                        searchString: searchString,
                        language: language,
                        lat: lat,
                        lon: lon
                    });
                    return _ctx.abrupt("return", (0,_request__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("".concat(basePath, "/").concat(lang, "/search/autocomplete-locations?limit=", 10, "&").concat(query)).then(function(r) {
                        return r.json();
                    }));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getLocationsAutocomplete(_) {
        return _ref.apply(this, arguments);
    };
}();
var getLocationsAutocompleteSelfDatabase = function() {
    var _ref = _asyncToGenerator(_builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var locationId, lang, keywordId, search, type, searchParams, queryParams, url;
        return _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    locationId = param.locationId, lang = param.lang, keywordId = param.keywordId, search = param.search, type = param.type;
                    searchParams = new URLSearchParams();
                    if (keywordId && keywordId !== 1) {
                        searchParams.append("keywordId", keywordId.toString());
                    }
                    if (search === null || search === void 0 ? void 0 : search.length) {
                        searchParams.append("search", search);
                    }
                    if (type) {
                        searchParams.append("type", type);
                    }
                    queryParams = searchParams.toString();
                    url = "".concat(internalApiUrl, "/").concat(lang, "/api/search/locations");
                    if (locationId) {
                        url += "/".concat(locationId);
                    }
                    if (queryParams === null || queryParams === void 0 ? void 0 : queryParams.length) {
                        url += "?".concat(queryParams);
                    }
                    return _ctx.abrupt("return", (0,_request__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(url).then(function(r) {
                        return r.json();
                    }));
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getLocationsAutocompleteSelfDatabase(_) {
        return _ref.apply(this, arguments);
    };
}();
var getLocationDetails = function() {
    var _ref = _asyncToGenerator(_builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var locationId, lang;
        return _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    locationId = param.locationId, lang = param.lang;
                    return _ctx.abrupt("return", (0,_request__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("".concat(basePath, "/").concat(lang, "/search/location-details/").concat(locationId)).then(function(r) {
                        return r.json();
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getLocationDetails(_) {
        return _ref.apply(this, arguments);
    };
}();
var getSearchAutocomplete = function() {
    var _ref = _asyncToGenerator(_builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var searchString, lang, type, specialties, searchType, query;
        return _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    searchString = param.searchString, lang = param.lang, type = param.type, specialties = param.specialties, searchType = param.searchType;
                    query = (0,_utils_query__WEBPACK_IMPORTED_MODULE_2__/* .transformToQuery */ .aR)({
                        searchString: searchString,
                        type: type,
                        specialties: specialties,
                        searchType: searchType
                    });
                    return _ctx.abrupt("return", (0,_request__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("".concat(basePath, "/").concat(lang, "/search/autocomplete?limit=", 10, "&").concat(query)).then(function(r) {
                        return r.json();
                    }));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSearchAutocomplete(_) {
        return _ref.apply(this, arguments);
    };
}();
var getSearchKeywords = function() {
    var _ref = _asyncToGenerator(_builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var keywordId, keywordType, locationId, locale, url;
        return _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    keywordId = param.keywordId, keywordType = param.keywordType, locationId = param.locationId, locale = param.locale;
                    url = "".concat(internalApiUrl, "/").concat(locale, "/api/keywords?");
                    if (keywordType) {
                        url += "keyword_type=".concat(keywordType, "&");
                    }
                    if (locationId) {
                        url += "locationId=".concat(locationId);
                    }
                    if (keywordId && keywordId !== 1) {
                        url += "&keywordId=".concat(keywordId);
                    }
                    return _ctx.abrupt("return", (0,_request__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(url).then(function(r) {
                        return r.json();
                    }));
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSearchKeywords(_) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 91633:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var highlightText = function(text, value) {
    if (!value) {
        return text;
    }
    var regString = value.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
    var regExp = new RegExp(regString, "ig");
    return text.replace(regExp, function(str) {
        return '<b class="text-highlight">'.concat(str, "</b>");
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (highlightText);


/***/ }),

/***/ 23099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EC": function() { return /* binding */ transformAutocompleteKeyword; },
/* harmony export */   "ae": function() { return /* binding */ transformAutocompleteSpecialist; },
/* harmony export */   "bS": function() { return /* binding */ alternativeTransformAutocompletePractices; },
/* harmony export */   "dP": function() { return /* binding */ transformAutocompletePractices; },
/* harmony export */   "lT": function() { return /* binding */ transformSearchType; }
/* harmony export */ });
/* harmony import */ var _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3842);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var transformAutocompleteSpecialist = function(profile, language) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    return {
        name: "".concat(profile === null || profile === void 0 ? void 0 : (ref = profile.firstName) === null || ref === void 0 ? void 0 : ref[language], " ").concat((ref1 = profile.lastName) === null || ref1 === void 0 ? void 0 : ref1[language]).trim() || "",
        id: profile === null || profile === void 0 ? void 0 : profile.id,
        slug: profile === null || profile === void 0 ? void 0 : profile.slug,
        logo: profile === null || profile === void 0 ? void 0 : (ref2 = profile.images) === null || ref2 === void 0 ? void 0 : ref2.logo,
        subtitle: (ref4 = profile === null || profile === void 0 ? void 0 : (ref3 = profile.keywords) === null || ref3 === void 0 ? void 0 : ref3.find(function(f) {
            return f.keywordType === "specialty";
        })) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.name) === null || ref5 === void 0 ? void 0 : ref5[language]
    };
};
var transformAutocompletePractices = function(profile, language) {
    var ref, ref6;
    return {
        name: (profile === null || profile === void 0 ? void 0 : (ref = profile.name) === null || ref === void 0 ? void 0 : ref[language]) || "",
        id: profile === null || profile === void 0 ? void 0 : profile.id,
        slug: profile === null || profile === void 0 ? void 0 : profile.slug,
        logo: profile === null || profile === void 0 ? void 0 : (ref6 = profile.images) === null || ref6 === void 0 ? void 0 : ref6.logo,
        subtitle: ""
    };
};
var alternativeTransformAutocompletePractices = function(profile, language) {
    var ref, ref7;
    return {
        name: (profile === null || profile === void 0 ? void 0 : (ref = profile.name) === null || ref === void 0 ? void 0 : ref[language]) || "",
        id: profile === null || profile === void 0 ? void 0 : profile.id,
        slug: profile === null || profile === void 0 ? void 0 : profile.slug,
        logo: profile === null || profile === void 0 ? void 0 : (ref7 = profile.images) === null || ref7 === void 0 ? void 0 : ref7.cover,
        subtitle: ""
    };
};
var transformAutocompleteKeyword = function(keyword, language) {
    var ref;
    return {
        name: (keyword === null || keyword === void 0 ? void 0 : (ref = keyword.name) === null || ref === void 0 ? void 0 : ref[language]) || "",
        id: keyword === null || keyword === void 0 ? void 0 : keyword.id,
        slug: keyword === null || keyword === void 0 ? void 0 : keyword.slug[0],
        logo: keyword === null || keyword === void 0 ? void 0 : keyword.iconUri,
        subtitle: "",
        type: keyword.type
    };
};
var transformSearchType = function(type) {
    var _obj;
    var obj = (_obj = {}, _defineProperty(_obj, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .SearchTypes.specialists */ .ai.specialists, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .AlternativeNavigationSearchTypes.specialists */ .g7.specialists), _defineProperty(_obj, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .SearchTypes.practices */ .ai.practices, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .AlternativeNavigationSearchTypes.practices */ .g7.practices), _defineProperty(_obj, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .SearchTypes.dentist */ .ai.dentist, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .AlternativeNavigationSearchTypes.dentist */ .g7.dentist), _defineProperty(_obj, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .SearchTypes.healthAndSocialCare */ .ai.healthAndSocialCare, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .AlternativeNavigationSearchTypes.healthAndSocialCare */ .g7.healthAndSocialCare), _defineProperty(_obj, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .SearchTypes.hospital */ .ai.hospital, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .AlternativeNavigationSearchTypes.hospital */ .g7.hospital), _defineProperty(_obj, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .SearchTypes.pharmacy */ .ai.pharmacy, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .AlternativeNavigationSearchTypes.pharmacy */ .g7.pharmacy), _defineProperty(_obj, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .SearchTypes.careHome */ .ai.careHome, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .AlternativeNavigationSearchTypes.careHome */ .g7.careHome), _obj);
    return obj[type] || type;
};


/***/ }),

/***/ 725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lr": function() { return /* binding */ Carousel; },
  "qs": function() { return /* binding */ CarouselSlide; }
});

// UNUSED EXPORTS: AutoScroll, CarouselNavButton

// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/react-intersection-observer/index.esm.js
var index_esm = __webpack_require__(92320);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@splidejs/react-splide/dist/js/react-splide.esm.esm.js
var react_splide_esm_esm = __webpack_require__(29465);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/styled.esm.js + 21 modules
var styled_esm = __webpack_require__(84857);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Box/Box.esm.js + 2 modules
var Box_esm = __webpack_require__(26546);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Button/Button.esm.js + 3 modules
var Button_esm = __webpack_require__(93247);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/components/Carousel/styles.esm.js




(0,styled_esm/* default */.Z)(Box_esm/* default */.Z)({
    position: 'relative'
});
const NavigationContainer = (0,styled_esm/* default */.Z)(Box_esm/* default */.Z, {
    shouldForwardProp: (prop) => prop !== 'bottom' && prop !== 'laterally' && prop !== 'inside' && prop !== 'navigationPosition'
})(({ navigationPosition, theme }) => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (navigationPosition === 'bottom' && {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px'
})), { zIndex: 3 }), (navigationPosition === 'laterally' && {
    button: {
        position: 'absolute',
        zIndex: 500,
        top: 'calc(50% - 20px)',
        '&:first-of-type': {
            left: '-25px'
        },
        '&:last-of-type': {
            right: '-25px'
        }
    }
})), (navigationPosition === 'inside' && {
    position: 'absolute',
    display: 'flex',
    marginTop: '40px',
    width: '30%',
    justifyContent: 'center',
    gap: '10px',
    bottom: '50px',
    zIndex: 1
})), { [theme.breakpoints.down('sm')]: Object.assign({}, (navigationPosition === 'laterally' && {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        justifyContent: 'center',
        gap: '25px',
        marginTop: '35px',
        button: {
            left: '0 !important',
            right: '0 !important',
            position: 'relative'
        }
    })) })));
const NavButton = (0,styled_esm/* default */.Z)(Button_esm/* default */.Z)(({ theme }) => ({
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    padding: 0,
    minWidth: 'auto',
    border: `0.2px solid ${theme.palette.common.white}`,
    backgroundColor: theme.palette.background.paper,
    transition: '0.2s',
    '&.Mui-disabled': {
        pointerEvents: 'auto !important',
        'svg > path': {
            fill: '#D9D9D9'
        },
        '&:hover': {
            backgroundColor: theme.palette.background.paper,
            'svg > path': {
                fill: '#D9D9D9'
            }
        }
    },
    '&:hover': {
        backgroundColor: theme.palette.primary.main,
        'svg > path': {
            fill: theme.palette.background.default
        }
    },
    [theme.breakpoints.down('sm')]: {
        width: '40px',
        height: '40px'
    }
}));
(0,styled_esm/* default */.Z)(Box_esm/* default */.Z)({
    display: 'grid',
    gap: '45px',
    width: 'inherit',
    minHeight: 'max-content',
    '&>div': {
        width: 'inherit'
    }
});



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/_virtual/_tslib.esm.js
var _tslib_esm = __webpack_require__(10395);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/theme/index.esm.js + 26 modules
var theme_index_esm = __webpack_require__(1189);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/SvgIcon/SvgIcon.esm.js + 1 modules
var SvgIcon_esm = __webpack_require__(46224);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/CarouselArrow/index.esm.js





const CarouselArrow = (_a) => {
    var { color, rotation } = _a, props = (0,_tslib_esm/* __rest */._)(_a, ["color", "rotation"]);
    return (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ viewBox: "0 0 17 18" }, props, { sx: {
            transform: `rotate(${rotation}deg)`
        } }),
        react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.59233 2.40768L7.59 2.41L13.17 8L1 8C0.447716 8 9.24263e-08 8.44772 9.90123e-08 9C1.05598e-07 9.55229 0.447716 10 1 10L13.17 10L7.59 15.59L7.59186 15.5919C7.39739 15.7737 7.27585 16.0326 7.27585 16.3198C7.27585 16.8701 7.72195 17.3162 8.27224 17.3162C8.56187 17.3162 8.82264 17.1926 9.00469 16.9953L17 9L9.03428 1.03429C8.85171 0.827455 8.5846 0.697006 8.28703 0.697006C7.73673 0.697006 7.29063 1.14311 7.29063 1.6934C7.29063 1.97352 7.40623 2.22665 7.59233 2.40768Z", fill: color || theme_index_esm/* theme.palette.primary.main */.rS.palette.primary.main })));
};



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Grid/Grid.esm.js + 2 modules
var Grid_esm = __webpack_require__(54597);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/components/Carousel/index.esm.js











const CarouselSlide = (0,styled_esm/* default */.Z)(react_splide_esm_esm/* SplideSlide */.jw)({});
const CarouselNavButton = ({ onClick, type, refObj, sx = {} }) => (react.createElement(NavButton, { ref: refObj, sx: Object.assign({ backgroundColor: theme_index_esm/* theme.palette.background.default */.rS.palette.background["default"] }, sx), onClick: onClick, "aria-label": `carousel-navigation-${type}` },
    type === 'next' && react.createElement(CarouselArrow, null),
    type === 'prev' && react.createElement(CarouselArrow, { rotation: 180 })));
const Carousel = ({ children, slidesPerView = 3, navigation = false, navigationPosition = 'laterally', navigationElement = null, pagination = false, isRtl = false, spaceBetween, slidesPerGroup = 1, updateOnMove = false, loop = false, vertical = false, currentSlide = 0, verticalHeight, trimSpace = false, centerFocus = false, slidePadding = 0, wheel = false, lazyLoad = false, sx = {}, breakpoints = {}, disableDrag = false, options = {}, navButtonStyles = {}, onRefReady, extensions = {} }) => {
    const splide = (0,react.useRef)(null);
    const prevRef = (0,react.useRef)(null);
    const nextRef = (0,react.useRef)(null);
    const [perPage, setPerPage] = react.useState(slidesPerView);
    const { ref, inView } = (0,index_esm/* useInView */.YD)({
        triggerOnce: true,
        skip: !lazyLoad,
        trackVisibility: lazyLoad,
        delay: 500,
        threshold: 0.25
    });
    (0,react.useEffect)(() => {
        var _a, _b, _c;
        const splideInstance = (_a = splide === null || splide === void 0 ? void 0 : splide.current) === null || _a === void 0 ? void 0 : _a.splide;
        if (!splideInstance) {
            return;
        }
        if (inView && lazyLoad) {
            splideInstance.options = Object.assign(Object.assign({}, splideInstance.options), { autoplay: !!(options === null || options === void 0 ? void 0 : options.autoplay) });
            if (splideInstance.options.autoplay) {
                (_b = splideInstance.Components.Autoplay) === null || _b === void 0 ? void 0 : _b.play();
            }
            else {
                (_c = splideInstance.Components.Autoplay) === null || _c === void 0 ? void 0 : _c.pause();
            }
            if (options === null || options === void 0 ? void 0 : options.autoScroll) {
                splideInstance.options = Object.assign(Object.assign({}, splideInstance.options), { autoScroll: (options === null || options === void 0 ? void 0 : options.autoScroll) ? options === null || options === void 0 ? void 0 : options.autoScroll : false, extensions: (options === null || options === void 0 ? void 0 : options.autoScroll) ? options === null || options === void 0 ? void 0 : options.extensions : {} });
                splideInstance.destroy();
                splideInstance.mount();
            }
        }
    }, [inView, lazyLoad, options === null || options === void 0 ? void 0 : options.autoScroll, options === null || options === void 0 ? void 0 : options.autoplay, options === null || options === void 0 ? void 0 : options.extensions]);
    (0,react.useEffect)(() => {
        if (onRefReady) {
            onRefReady(splide.current);
        }
    }, [onRefReady]);
    (0,react.useEffect)(() => {
        if (splide.current) {
            splide.current.go(currentSlide);
        }
    }, [currentSlide, splide]);
    const handleNext = () => {
        var _a;
        (_a = splide.current) === null || _a === void 0 ? void 0 : _a.go('+1');
    };
    const handlePrev = () => { var _a; return (_a = splide.current) === null || _a === void 0 ? void 0 : _a.go('-1'); };
    const directionScroll = (0,react.useMemo)(() => (isRtl ? 'rtl' : 'ltr'), [isRtl]);
    return (react.createElement(Grid_esm/* default */.ZP, { ref: ref, md: 12, lg: 12, xs: 12, sx: sx },
        react.createElement(react_splide_esm_esm/* Splide */.tv, { ref: splide, options: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (vertical
                ? {
                    direction: 'ttb',
                    height: `${verticalHeight}px`,
                    trimSpace,
                    focus: centerFocus ? 'center' : undefined
                }
                : {})), { type: loop ? 'loop' : 'slide', direction: directionScroll, paginationDirection: directionScroll, perPage: slidesPerView, perMove: slidesPerGroup, pagination, arrows: false, gap: spaceBetween, updateOnMove, padding: `${slidePadding}rem`, wheel, drag: !disableDrag, breakpoints }), (lazyLoad
                ? {
                    lazyLoad: 'nearby'
                }
                : {})), options), { autoScroll: lazyLoad ? false : options === null || options === void 0 ? void 0 : options.autoScroll, autoplay: lazyLoad ? false : options === null || options === void 0 ? void 0 : options.autoplay }), onMounted: (e) => {
                setPerPage((e === null || e === void 0 ? void 0 : e.options.perPage) || slidesPerView);
            }, extensions: extensions }, children),
        react.createElement(Grid_esm/* default */.ZP, { sx: { display: 'flex', gap: '16px', alignItems: 'center', justifyContent: 'space-between', width: '100%' } },
            navigationElement,
            navigation && react.Children.count(children) > perPage && (react.createElement(NavigationContainer, { navigationPosition: navigationPosition },
                react.createElement(CarouselNavButton, { refObj: prevRef, sx: navButtonStyles, onClick: handlePrev, type: isRtl ? 'next' : 'prev' }),
                react.createElement(CarouselNavButton, { refObj: nextRef, sx: navButtonStyles, onClick: handleNext, type: isRtl ? 'prev' : 'next' }))))));
};




/***/ })

}]);